import React from 'react';

import {VisibilityOff, Visibility} from '@material-ui/icons';
import {Ripple} from "../../Buttons";

const Component = ({Input, ...props}) => {
  const [showPassword, setShowPasswordState] = React.useState();

  const VisibilityIcon = showPassword
    ? VisibilityOff
    : Visibility;

  return (
    <Input
      {...props}
      className={!showPassword ? 'dot-view' : ''}
      type={showPassword ? 'text' : 'password'}
      endAdornment={(
        <Ripple
          onClick={() => {
            setShowPasswordState(!showPassword);
          }}
        >
          <VisibilityIcon
            className="c0C"
          />
        </Ripple>
      )}
    />
  )
}

export default (Input) => (props) => (
  <Component
    {...props}
    Input={Input}
  />
)
